import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-dark pt-20 pb-32 overflow-hidden" data-id="element-62">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-63">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-65">
            <div className="inline-block bg-dark-card border border-dark-border rounded-full px-4 py-1.5 mb-6" data-id="element-66">
              <span className="text-sm font-medium text-gray-300" data-id="element-67">
                🔥 +8,000 hombres ya se liberaron
              </span>
            </div>

            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mb-6 uppercase" data-id="element-68">
              Deja la pornografía de forma inmediata, indolora y permanente{' '}
              <span className="text-gray-400" data-id="element-69">
                — sin fuerza de voluntad, sin sacrificio
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-70">
              El método que utilizan miles de hombres para liberarse del ciclo,
              sin rachar días ni dietas de porno.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-71">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-accent hover:bg-accent-hover text-white font-bold py-5 px-10 rounded-lg text-xl w-full sm:w-auto shadow-[0_0_30px_rgba(255,77,26,0.3)] transition-all" data-id="element-72">
                LIBÉRATE AHORA 👉
              </motion.button>

              <div className="flex items-center gap-3 mt-2" data-id="element-73">
                <span className="text-gray-400 line-through text-lg" data-id="element-74">$27</span>
                <span className="text-white font-bold text-3xl" data-id="element-75">$17</span>
                <span className="bg-accent/20 text-accent text-xs font-bold px-2 py-1 rounded uppercase tracking-wide" data-id="element-76">
                  Ahorra 37%
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-77">
            <div className="relative w-full aspect-[3/4] max-w-sm mx-auto perspective-1000" data-id="element-78">
              <div className="absolute inset-0 bg-gradient-to-br from-[#0f172a] to-[#020617] rounded-r-2xl rounded-l-sm shadow-2xl border border-gray-800 transform rotate-y-[-15deg] rotate-x-[5deg] preserve-3d flex flex-col justify-between p-8 overflow-hidden" data-id="element-79">
                {/* Book spine effect */}
                <div className="absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-black/60 to-transparent z-10" data-id="element-80"></div>

                {/* Book cover content */}
                <div className="relative z-20" data-id="element-81">
                  <p className="text-gray-400 text-xs tracking-widest uppercase mb-4" data-id="element-82">
                    Odyssey Presenta
                  </p>
                  <h3 className="font-display text-3xl font-bold text-white leading-snug uppercase" data-id="element-83">
                    La Escapatoria
                    <br data-id="element-84" />
                    <span className="text-accent" data-id="element-85">Sin Esfuerzo</span>
                  </h3>
                </div>

                <div className="relative z-20 mt-auto" data-id="element-86">
                  <div className="w-12 h-1 bg-accent mb-4" data-id="element-87"></div>
                  <p className="text-sm text-gray-300 font-medium" data-id="element-88">
                    Recupera Tu Tiempo, Relaciones y Confianza
                  </p>
                </div>

                {/* Decorative glow */}
                <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-accent/20 blur-[80px] rounded-full" data-id="element-89"></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}